import { MixpanelAssistantMode } from "#types/tracking.ts";
import type { AssistantMode } from "#types/types.ts";
import { create } from "zustand";

export type ReasoningEffort = "auto" | "standard" | "high";

interface AssistantModeStore {
    reasoningEffort: ReasoningEffort;
    setReasoningEffort: (reasoningEffort: ReasoningEffort) => void;
}

export const useAssistantModeStore = create<AssistantModeStore>()(set => ({
    reasoningEffort: "auto",
    setReasoningEffort: (reasoningEffort: ReasoningEffort) => set({ reasoningEffort })
}));

// The wire calls High "pro" and Standard "fast".
export const ASSISTANT_MODE_BY_EFFORT: Record<ReasoningEffort, AssistantMode> = {
    auto: "auto",
    standard: "fast",
    high: "pro"
};

export const MIXPANEL_ASSISTANT_MODE: Record<AssistantMode, MixpanelAssistantMode> = {
    auto: MixpanelAssistantMode.Auto,
    pro: MixpanelAssistantMode.Pro,
    fast: MixpanelAssistantMode.Fast
};
